import React, { useState, useEffect } from "react";
import { Autocomplete, TextField, Box, IconButton } from "@mui/material";
import CachedIcon from "@mui/icons-material/Cached";
import LinkIcon from "@mui/icons-material/Link";
import { UseProductMaterial } from "./UseProductMaterial";

export default function MaterialAutoComplete(props) {
  const { getAllMaterialList } = UseProductMaterial();
  const [productMateraialRes, setProductMateraialRes] = useState();
  const [selectedMaterial, setSelectedMaterial] = useState();

  useEffect(() => {
    getAllMaterialList((materials) => {
      setProductMateraialRes(materials);
    });
  }, []);

  useEffect(() => {
    if (productMateraialRes && props.selectedMaterialID) {
      setSelectedMaterial(
        productMateraialRes.materials.find(
          (m) => m.id == props.selectedMaterialID
        )
      );
    }
  }, [productMateraialRes, props.selectedMaterialID]);

  useEffect(() => {
    if (selectedMaterial) {
      props.setter({
        ...props.lvl2State,
        materialID: selectedMaterial.id,
      });
    }
  }, [selectedMaterial]);

  return productMateraialRes ? (
    <Box sx={{ display: "flex", alignItems: "center" }}>
      <Autocomplete
        disablePortal
        value={selectedMaterial ? selectedMaterial : ""}
        id="combo-box-demo"
        options={
          productMateraialRes.materials ? productMateraialRes.materials : []
        }
        getOptionLabel={(materials) => (materials.name ? materials.name : "")}
        isOptionEqualToValue={(option, value) => option.value === value.value}
        renderInput={(params) => <TextField {...params} label="جنس محصول" />}
        renderOption={(props, option) => {
          return (
            <li {...props} key={option.id}>
              {option.name ? option.name : ""}
            </li>
          );
        }}
        onChange={(evt, newValue) => {
          if (newValue) {
            setSelectedMaterial(newValue);
          } else {
            setSelectedMaterial();
            props.setter({
              ...props.lvl2State,
              materialID: 0,
            });
          }
        }}
        fullWidth
        size="small"
      />
      <IconButton
        sx={{ p: 0, m: 1 }}
        onClick={() => {
          getAllMaterialList((materials) => {
            setProductMateraialRes(materials);
          });
        }}
      >
        <CachedIcon fontSize="small" />
      </IconButton>
      <IconButton sx={{ p: 0 }} href="/productmaterial" target="_blank">
        <LinkIcon fontSize="small" />
      </IconButton>
    </Box>
  ) : (
    ""
  );
}

{
}
